import React from 'react';

export const Delete: React.FC = () => <i className="fa fa-trash-o" aria-hidden="true" />;
export const Plus: React.FC = () => <i className="fa fa-plus" aria-hidden="true" />;
export const Edit: React.FC = () => <i className="fa fa-pencil" aria-hidden="true" />;
export const DeleteFill: React.FC = () => <i className="fa fa-trash-o" aria-hidden="true" />;
export const EditFill: React.FC = () => <i className="fa fa-pencil" aria-hidden="true" />;
export const Search: React.FC = () => <i className="fa fa-search" aria-hidden="true" />;
export const Download: React.FC = () => <i className="fa fa-download" aria-hidden="true" />;
export const EllipsisH: React.FC = () => <i className="fa fa-ellipsis-h" aria-hidden="true" />;
export const ChevronRight: React.FC = () => (
  <i className="fa fa-chevron-right" aria-hidden="true"></i>
);
export const ChevronLeft: React.FC = () => (
  <i className="fa fa-chevron-left" aria-hidden="true"></i>
);
export const Menu: React.FC = () => <i className="fa fa-bars" aria-hidden="true"></i>;
export const Logout: React.FC = () => <i className="fa fa-sign-out" aria-hidden="true"></i>;
export const User: React.FC = () => <i className="fa fa-user" aria-hidden="true"></i>;
export const MapMarker: React.FC = () => <i className="fa fa-map-marker" aria-hidden="true"></i>;
export const Building: React.FC = () => <i className="fa fa-building-o" aria-hidden="true"></i>;
export const Memo: React.FC = () => <i className="fa fa-sticky-note" aria-hidden="true"></i>;
export const Home: React.FC = () => <i className="fa fa-home" aria-hidden="true"></i>;
export const Refresh: React.FC = () => <i className="fa fa-refresh" aria-hidden="true"></i>;
export const Eye: React.FC = () => <i className="fa fa-eye" aria-hidden="true"></i>;

/** Vòng tròn có dấu tích — nhãn 「SSO連携済み」 ở màn 管理者一覧 (BD sheet 2, mục 6.0). */
export const CheckCircleO: React.FC = () => (
  <i className="fa fa-check-circle-o" aria-hidden="true"></i>
);

/** Mắt xích — nút 「SSO連携」 ở màn 管理者一覧 (BD sheet 2, mục 7.0). */
export const Link: React.FC = () => <i className="fa fa-link" aria-hidden="true"></i>;
